import React, {useEffect, useState} from "react";
import Api from "../../Api/api";
import {ClipLoader, SkewLoader} from "react-spinners";
import {useForm} from "react-hook-form";
import {toast} from "react-toastify";
import {useStateValue} from "../../states/StateProvider";
import {Link} from "react-router-dom";
import {AES, enc} from "crypto-js";
import {useNavigate} from "react-router";

const InfoCrawler = () => {

    const [{ICSaved, secretKey, portal}, dispatch] = useStateValue();
    const [milestones, setMilestones] = useState([])
    const [subStepsLoading, setSubStepsLoading] = useState(false)
    const [triggerSubStepsLoading, setTriggerSubStepsLoading] = useState(false)
    const [subSteps, setSubSteps] = useState([])
    const [triggerSubSteps, setTriggerSubSteps] = useState([])
    const [loading, setLoading] = useState(true)
    const [loadingGrid, setLoadingGrid] = useState(false)
    const [deleteClicked, setDeleteClicked] = useState(false)
    const [deleteDone, setDeleteDone] = useState(false)
    const [loadingSave, setLoadingSave] = useState(false)
    const [milestoneSelected, seMilestoneSelected] = useState()
    const [TriggerMilestoneSelected, setTriggerMilestoneSelected] = useState()
    const [SubStepSelected, setSubStepSelected] = useState()
    const decryptedBytes = localStorage.getItem('user') ? AES.decrypt(localStorage.getItem('user'), secretKey) : false;
    const user = JSON.parse(decryptedBytes.toString(enc.Utf8))
    const navigate = useNavigate()
    const {
        register, getValues, setValue, watch, handleSubmit, formState, reset, formState: {errors, touchedFields},
    } = useForm({mode: "onChange"});

    useEffect(() => {
        if (user.isICAdmin === '0') {
            navigate('/')
        }

        reset()

        Api().get(`getMilestoneCrawler/${portal}`).then(res => {
            setMilestones(res.data)
            setLoading(false)
        }).then(r => {
            GetSubSteps(milestoneSelected)
        }).then(r => {
            getGrid(milestoneSelected, SubStepSelected, true)
        }).catch(e => {
            setLoadingGrid(false)
        });
    }, [ICSaved, portal]);

    useEffect(() => {
        const triggerMilestoneID = getValues('triggerMilestoneID');
        if (triggerMilestoneID && triggerMilestoneID !== 'Wählen Sie einen Meilenstein aus') {
            setTriggerSubSteps([]);
            setTriggerSubStepsLoading(true);
            Api().get(`getSubStepsCrawler/${portal}/${triggerMilestoneID}`)
                .then(res => {
                    setTriggerSubSteps(res.data);
                    setTriggerSubStepsLoading(false);
                }).catch(e => {
                setLoadingGrid(false)
            });
        }
    }, [getValues('triggerMilestoneID')]);

    const milestoneChanged = (e) => {
        reset()
        setSubStepsLoading(true)
        seMilestoneSelected(e.target.value)
        GetSubSteps(e.target.value)
    }

    function GetSubSteps(milestone) {
        setSubSteps([])
        Api().get(`getSubStepsCrawler/${portal}/${milestone}`).then(res => {
            setSubSteps(res.data)
            setSubStepSelected(res.data[0]?.substepID)
            setSubStepsLoading(false)
            getGrid(milestone, res.data[0].substepID, true)
        }).catch(e => {
            setLoadingGrid(false)
        });
    }

    const triggerMilestoneSelected = (e) => {
        setTriggerMilestoneSelected(e.target.value);
        setTriggerSubStepsLoading(true);
        setTriggerSubSteps([]);
        setValue('triggerMilestoneID', e.target.value)
        setValue('triggerSubstepID', '1');
        Api().get(`getSubStepsCrawler/${portal}/${e.target.value}`).then(res => {
            setTriggerSubSteps(res.data);
            setValue('triggerSubstepID', '1');
            setTriggerSubStepsLoading(false);
        }).catch(e => {
            setLoadingGrid(false)
        });
    };

    const subStepSelected = (e) => {
        reset()
        setSubStepSelected(e.target.value)
        getGrid(milestoneSelected, e.target.value, true)
    }

    const getGrid = (milestone, subStep, isLoading) => {
        setLoadingGrid(isLoading)
        Api().get(`sp_getDataIC/${portal}/${milestone}/${subStep}`).then(res => {
            res.data.map(r => {
                Object.keys(r).forEach((key) => {
                    if (key.includes('Berater') || key.includes('DGAPI') || key.includes('DGAPIKAM') || key.includes('DGAPIAMS') || key.includes('DGKAM') || key.includes('VA') || key.includes('FKB') || key.includes('KBD') || key.includes('VLHS') || key.includes('VBbV') || key.includes('ADM') || key.includes('cc') || key.includes('SB') || key.includes('KGS')) {
                        if (r[key] === '0') {
                            r[key] = false
                        } else if (r[key] === '1') {
                            r[key] = true
                        }
                    }
                    setValue(key, r[key]);
                    if (key === 'remind1cc' && r[key]) {
                        setValue('remind1cc', 1)
                        setValue('remind1ccText', r[key])
                    }
                    if (key === 'remind2cc' && r[key]) {
                        setValue('remind2cc', 1)
                        setValue('remind2ccText', r[key])
                    }
                    if (key === 'remind3cc' && r[key]) {
                        setValue('remind3cc', 1)
                        setValue('remind3ccText', r[key])
                    }
                });
            })
            setLoadingGrid(false)
        }).catch(e => {
            setLoadingGrid(false)
        })
    }

    const onSubmit = async (data) => {
        setLoadingSave(true)
        const modifiedData = {
            ...data, milestoneID: milestoneSelected, subStepID: SubStepSelected, portal: portal,
        };
        // console.log(modifiedData)

        Api().post('/sp_putIC1', modifiedData).then(res => {
            if (res.status === 201) {
                toast.success('Abschnitt 1 Daten gespeichert')
            }
            setLoadingSave(false)
        }).catch(e => {
            setLoadingSave(false)
            toast.error('Beim Speichern von Abschnitt 1 ist ein Fehler aufgetreten!')
        })

        Api().post('/sp_putIC2', modifiedData).then(res => {
            if (res.status === 201) {
                toast.success('Abschnitt 2 Daten gespeichert')
            }
            setLoadingSave(false)
        }).catch(e => {
            setLoadingSave(false)
            toast.error('Beim Speichern von Abschnitt 2 ist ein Fehler aufgetreten!')
        })

        Api().post('/sp_putIC3', modifiedData).then(res => {
            if (res.status === 201) {
                toast.success('Abschnitt 3 Daten gespeichert')
            }
            dispatch({type: "SET_ICSAVED", item: !ICSaved})
            setLoadingSave(false)
        }).catch(e => {
            setLoadingSave(false)
            toast.error('Beim Speichern von Abschnitt 3 ist ein Fehler aufgetreten!')
        }).finally(e => {
            reset()
            getGrid(milestoneSelected, SubStepSelected, true)
        })
    };

    const deleteIC = () => {
        Api().post(`sp_deleteIC/${portal}/${milestoneSelected}/${SubStepSelected}`).then(res => {
            if (res.data === 1) {
                toast.success('Erfolgreich gelöscht')
                setDeleteClicked(false)
            } else {
                toast.error('etwas ist schief gelaufen!')
            }
        }).catch(e => {
            toast.error('etwas ist schief gelaufen!')
        })
        setDeleteDone(!deleteDone)
        getGrid(milestoneSelected, SubStepSelected, true)
        handleReset()
    }

    const handleReset = () => {
        const values = getValues();
        const updatedValues = {};
        Object.keys(values).forEach((key) => {
            updatedValues[key] = null;
        });

        reset(updatedValues);
    };

    function portalSelect(e) {
        dispatch({type: 'SET_PORTAL', item: e.target.value})
        localStorage.setItem('portal', e.target.value)
    }

    return (<div className={`dashboardContainer`}>
        <div className='flex justify-start items-center content-center pb-5'>
            <h2 className='text-2xl lg:text-left'> InfoCrawler</h2>
            {<div className='flex justify-start items-center w-fit bg-transparent py-2 px-4 ml-2 rounded-sm'>
                <p className='w-fit mr-2 text-grey'>Portal: </p>
                <select
                    disabled={loading || loadingSave || loadingGrid}
                    className='col-span-2 text-center text-mainBlue mx-auto pr-1 bg-transparent border border-offWhite rounded-sm lg:w-fit'
                    onChange={portalSelect}
                    value={portal}
                >
                    <option selected value='dgg'>DGG</option>
                    <option value='ruv'>R+V</option>
                </select>
            </div>}
        </div>
        {loading ? <SkewLoader size='10px'/> : user.isICAdmin === '1' &&
            <div className={`bg-white rounded-xl text-left px-8 py-8`}>
                <div
                    className={`${(!deleteClicked) && 'hideDiv'} shadow shadow-xl md:w-96 w-11/12 shadow-text text-lg px-6 py-6  flex flex-col rounded-lg z-10 absolute bg-offWhite centerItemsAbsolute`}>
                    <p>Wollen Sie den Datensatz wirklich löschen?</p>
                    <p className={`${loadingGrid && 'hideDiv'} flex justify-start px-24 pt-5 text-sm text-md font-bold`}>
                        <button onClick={deleteIC}
                                className='bg-green mr-3 text-white px-5 hover:bg-white hover:text-green py-2 rounded-xl'>Ja
                        </button>
                        <button onClick={() => setDeleteClicked(false)}
                                className='bg-cancel hover:bg-white hover:text-cancel text-white px-5 py-2 rounded-xl'>Nein
                        </button>
                    </p>
                    <p className='mx-auto'>
                        {loadingGrid && <ClipLoader size={10} color='#3A46A9'/>}
                    </p>
                </div>
                <div className="grid grid-cols-[15%_auto] items-start gap-x-10">
                    {/* Column 1 – fixed label */}
                    <div className="pt-2">
                        <p className="text-text font-bold">Auftrag zu</p>
                    </div>

                    {/* Column 2 – milestone + substep + button aligned to right */}
                    <div className="flex flex-wrap items-center w-full gap-4">
                        {/* Milestone select + label */}
                        <div className="flex items-center gap-2">
                            <span className="text-gray-600">Ziel-Meilenstein</span>
                            <select
                                onChange={milestoneChanged}
                                className="pl-3 pr-6 py-2 bg-white border border-offWhite rounded-sm"
                            >
                                <option hidden={milestones.length > 0} value={null}>
                                    Ziel-Meilenstein auswählen
                                </option>
                                {milestones.map((m, i) => (<option
                                        className={m.hasIC === '1' ? 'bg-pending my-2 text-text' : ''}
                                        value={m.milestoneID}
                                        key={i}
                                    >
                                        {m.milestoneLabel}
                                    </option>))}
                            </select>

                        </div>

                        {/* Substep select + label */}
                        <div className="flex items-center gap-2">
                            {subStepsLoading ? (<SkewLoader size="10px" color="#3A46A9"/>) : (<>
                                    <span className="text-gray-600">Ziel-Schritt</span>
                                    <select
                                        onChange={subStepSelected}
                                        className="pl-3 pr-6 py-2 bg-white border border-offWhite rounded-sm"
                                    >
                                        {subSteps.length === 0 && !subStepsLoading ? (
                                            <option value={null}>Ziel-Schritt auswählen</option>) : (subSteps.map((s, i) => (<option
                                                    className={s.hasIC === '1' ? 'bg-pending my-2 text-text' : ''}
                                                    value={s.substepID}
                                                    key={i}
                                                >
                                                    {s.stepName}
                                                </option>)))}
                                    </select>
                                </>)}
                        </div>
                        <div className="ml-auto">
                            <Link
                                to="/mail-verlauf"
                                className="px-6 py-2 bg-mainBlue hover:bg-offWhite text-white hover:text-text rounded-md"
                            >
                                Mail Verlauf
                            </Link>
                        </div>
                    </div>
                </div>
                <div className="grid grid-cols-[15%_auto] items-start gap-x-10 mt-5">
                    {/* Column 1 – fixed label */}
                    <div className="pt-2">
                        <p className="text-text font-bold">Quellfeld zu Auftrag</p>
                    </div>

                    {/* Column 2 – milestone + substep + button aligned to right */}
                    <div className="flex flex-wrap items-center w-full gap-4">
                        {/* Milestone select + label */}
                        <div className="flex items-center gap-2">
                            <span className="text-gray-600">Quell-Meilenstein</span>
                            <select
                                {...register('triggerMilestoneID')}
                                onChange={triggerMilestoneSelected}
                                className='pl-3 pr-1 py-2 bg-white border border-offWhite rounded-sm lg:w-fit mx-3'>
                                <option hidden={milestones.length > 0} value={null}>
                                    Quell-Meilenstein auswählen
                                </option>
                                {milestones.map((m, i) => (<option value={m.milestoneID}
                                                                   key={i}>{m.milestoneLabel}</option>))}
                            </select>

                        </div>

                        {/* Substep select + label */}
                        <div className="flex items-center gap-2">
                            {triggerSubStepsLoading ? (<SkewLoader size="10px" color="#3A46A9"/>) : (<>
                                    <span className="text-gray-600">Quell-Schritt</span>
                                    <select
                                        {...register('triggerSubstepID')}
                                        className='pl-3 pr-1 py-2 bg-white border border-offWhite rounded-sm lg:w-fit'>
                                        {(!getValues('triggerMilestoneID') || getValues('triggerMilestoneID') === 'Wählen Sie einen Meilenstein aus') && !subStepsLoading ?
                                            <option value={null}>
                                                Quell-Schritt auswählen
                                            </option> : triggerSubSteps.map((s, i) => (Number(getValues('triggerMilestoneID')) === Number(milestoneSelected) ? Number(s.substepID) < Number(SubStepSelected) &&
                                                <option value={s.substepID}
                                                        key={i}>{s.stepName}</option> : <option value={s.substepID}
                                                                                                key={i}>{s.stepName}</option>))}
                                    </select>
                                </>)}
                        </div>
                    </div>
                </div>

                {loadingGrid ? <div className={'flex h-screen w-full centerItemsRelative bg-white'}>
                    <div className='-mt-32'><ClipLoader color={'#3A46A9'} size='70px'/></div>
                </div> : <div>
                    <form onSubmit={handleSubmit(onSubmit)} className='mt-6 rounded-lg'>
                        <div className="grid grid-cols-[15%_auto] gap-x-10 mb-4 bg-offWhite p-1">
                            <h2 className="text-xl font-bold text-mainBlue">Erinnerung 1</h2>
                            <div className="flex items-center space-x-2">
                                <span className="text-text">Versand nach</span>
                                <input
                                    className="w-12 py-1 px-2 border border-offWhite rounded text-mainBlue"
                                    placeholder="5"
                                    {...register('remind1days')}
                                    style={{border: errors.remind1days && '1px solid red'}}
                                />
                                <span className="text-text">Tagen</span>
                            </div>
                        </div>
                        <div className="grid grid-cols-[15%_auto] gap-x-10 mb-10">
                            <div className="space-y-3 border border-offWhite pl-3">
                                <label className={`block`}>
                                    an
                                </label>
                                <label className={'col-span-2 block'}>
                                    <input type='checkbox'
                                           className='mr-3'
                                           {...register('remind1Berater')}
                                           style={{border: errors.remind1Berater && '1px solid red'}}
                                    />
                                    {portal === 'dgg' ? 'Berater (Closer)' : 'Berater'}
                                </label>

                                <label className={`block`}>
                                    <input type='checkbox'
                                           className='mr-3'
                                           {...register('remind1VA')}
                                           style={{border: errors.remind1VA && '1px solid red'}}
                                    />
                                    VA
                                </label>

                                <label className={`block mb-3`}>
                                    <input type='checkbox'
                                           className='mr-3'
                                           {...register('remind1DGAPIAMS')}
                                           style={{border: errors.remind1DGAPIAMS && '1px solid red'}}
                                    />
                                    DGAPI AMS
                                </label>

                                <label className={`block`}>
                                    cc
                                </label>

                                {portal === 'dgg' ? <label className={`block`}>
                                    <input type='checkbox' className='mr-3 '
                                           {...register('remind1ADM')}
                                           style={{border: errors.remind1ADM && '1px solid red'}}
                                    />
                                    ADM
                                </label> : <label className={`block`}>
                                    <input type='checkbox' className='mr-3'
                                           {...register('remind1FKB')}
                                           style={{border: errors.remind1FKB && '1px solid red'}}
                                    />
                                    FKB
                                </label>}

                                {portal === 'dgg' ? <label className={`block`}>
                                    <input type='checkbox' className='mr-3'
                                           {...register('remind1DGKAM')}
                                           style={{border: errors.remind1DGKAM && '1px solid red'}}
                                    />
                                    DG KAM
                                </label> : <label className={`block`}>
                                    <input type='checkbox' className='mr-3'
                                           {...register('remind1DGAPIKAM')}
                                           style={{border: errors.remind1DGAPIKAM && '1px solid red'}}
                                    />
                                    DGAPI KAM
                                </label>}

                                {portal === 'dgg' ? <label className={`block`}>
                                    <input
                                        type='checkbox' className='mr-3'
                                        {...register('remind1KGS')}
                                        style={{border: errors.remind1KGS && '1px solid red'}}
                                    />
                                    KGS
                                </label> : <label className={`block`}>
                                    <input
                                        type='checkbox' className='mr-3'
                                        {...register('remind1KBD')}
                                        style={{border: errors.remind1KBD && '1px solid red'}}
                                    />
                                    KBD
                                </label>}

                                {portal === 'dgg' ? <label className={`block`}>
                                    <input type='checkbox' className='mr-3'
                                           {...register('remind1VLHS')}
                                           style={{border: errors.remind1VLHS && '1px solid red'}}
                                    />
                                    VLHS
                                </label> : <label className={`block`}>
                                    <input type='checkbox' className='mr-3'
                                           {...register('remind1VBbV')}
                                           style={{border: errors.remind1VBbV && '1px solid red'}}
                                    />
                                    VBbV
                                </label>}

                                <label className={`block`}>
                                    <input type='checkbox' className='mr-3'
                                           {...register('remind1SB')}
                                           style={{border: errors.remind1SB && '1px solid red'}}
                                    />
                                    SB
                                </label>
                            </div>
                            <div className="space-y-4">
                                <div className='flex justify-start my-2'>
                                    <label className='w-2/12 -mr-3' style={{lineBreak: 'strict'}}>
                                        <input type='checkbox' className='mr-3'
                                               {...register('remind1cc')}
                                               style={{border: errors.remind1cc && '1px solid red'}}
                                        />
                                        cc ebenfalls an
                                    </label>
                                    <input type='text' placeholder='info@anymail.com'
                                           {...register('remind1ccText')}
                                           style={{border: errors.remind1ccText && '1px solid red'}}
                                           className='py-2 w-full text-grey'/>
                                </div>
                                <div className='flex justify-start gap-4 my-2 mt-8'>
                                    <h5 className='w-2/12 -mr-3'>Betreff: </h5>
                                    <input type='text' className='py-2 w-full text-grey'
                                           {...register('remind1subject')}
                                           style={{border: errors.remind1subject && '1px solid red'}}
                                    />
                                </div>
                                <div className=' gap-4 my-2 mt-8'>
                                    <div className='flex flex-wrap gap-10'>
                                        <h5 className='w-2/12 -mr-3'>Mail-Text: </h5>
                                        <span className={`text-modalBackDropColor`}>
                                                Platzhalter:
                                                   <span className='px-2'>{'{'}Meilenstein{'}'}</span>
                                                   <span className='px-2'>{'{'}Schritt{'}'}</span>
                                                   <span className='px-2'>{'{'}Tage{'}'}</span>
                                                   <span className='px-2'>{'{'}Firmenprojekt{'}'}</span>
                                                   <span className='px-2'>{'{'}Link{'}'}</span>
                                            </span>
                                    </div>
                                    <textarea rows='8'
                                              className='border border-whiteDark rounded-sm w-full text-grey'
                                              {...register('remind1mail')}
                                              style={{
                                                  border: errors.remind1mail && '1px solid red', padding: '15px 40px'
                                              }}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="grid grid-cols-[15%_auto] gap-x-10 mb-4 bg-offWhite p-1">
                            <h2 className="text-xl font-bold text-mainBlue mr-3">Erinnerung 2</h2>
                            <div className="flex items-center space-x-2">
                                <span className="text-text">Versand nach</span>
                                <input
                                    className="w-12 py-1 px-2 border border-offWhite rounded text-mainBlue"
                                    placeholder="5"
                                    {...register('remind2days')}
                                    style={{border: errors.remind2days && '1px solid red'}}
                                />
                                <span className="text-text">Tagen</span>
                            </div>
                        </div>
                        <div className="grid grid-cols-[15%_auto] gap-x-10 mb-10">
                            <div className="space-y-3 border border-offWhite pl-3">
                                <label className={`block`}>
                                    an
                                </label>
                                <label className={'col-span-2 block'}>
                                    <input type='checkbox'
                                           className='mr-3'
                                           {...register('remind2Berater')}
                                           style={{border: errors.remind2Berater && '1px solid red'}}
                                    />
                                    {portal === 'dgg' ? 'Berater (Closer)' : 'Berater'}
                                </label>

                                <label className={`block`}>
                                    <input type='checkbox'
                                           className='mr-3'
                                           {...register('remind2VA')}
                                           style={{border: errors.remind2VA && '1px solid red'}}
                                    />
                                    VA
                                </label>

                                <label className={`block`}>
                                    <input type='checkbox'
                                           className='mr-3'
                                           {...register('remind2DGAPIAMS')}
                                           style={{border: errors.remind2DGAPIAMS && '1px solid red'}}
                                    />
                                    DGAPI AMS
                                </label>
                                <label className={`block`}>
                                    cc
                                </label>

                                {portal === 'dgg' ? <label className={`block`}>
                                    <input type='checkbox' className='mr-3'
                                           {...register('remind2ADM')}
                                           style={{border: errors.remind2ADM && '1px solid red'}}
                                    />
                                    ADM
                                </label> : <label className={`block`}>
                                    <input type='checkbox' className='mr-3'
                                           {...register('remind2FKB')}
                                           style={{border: errors.remind2FKB && '1px solid red'}}
                                    />
                                    FKB
                                </label>}

                                {portal === 'dgg' ? <label className={`block`}>
                                    <input type='checkbox' className='mr-3'
                                           {...register('remind2DGKAM')}
                                           style={{border: errors.remind2DGKAM && '1px solid red'}}
                                    />
                                    DG KAM
                                </label> : <label className={`block`}>
                                    <input type='checkbox' className='mr-3'
                                           {...register('remind2DGAPIKAM')}
                                           style={{border: errors.remind2DGAPIKAM && '1px solid red'}}
                                    />
                                    DGAPI KAM
                                </label>}


                                {portal === 'dgg' ? <label className={`block`}>
                                    <input
                                        type='checkbox' className='mr-3'
                                        {...register('remind2KGS')}
                                        style={{border: errors.remind2KGS && '1px solid red'}}
                                    />
                                    KGS
                                </label> : <label className={`block`}>
                                    <input
                                        type='checkbox' className='mr-3'
                                        {...register('remind2KBD')}
                                        style={{border: errors.remind2KBD && '1px solid red'}}
                                    />
                                    KBD
                                </label>}


                                {portal === 'dgg' ? <label className={`block`}>
                                    <input type='checkbox' className='mr-3'
                                           {...register('remind2VLHS')}
                                           style={{border: errors.remind2VLHS && '1px solid red'}}
                                    />
                                    VLHS
                                </label> : <label className={`block`}>
                                    <input type='checkbox' className='mr-3'
                                           {...register('remind2VBbV')}
                                           style={{border: errors.remind2VBbV && '1px solid red'}}
                                    />
                                    VBbV
                                </label>}

                                <label className={`block`}>
                                    <input type='checkbox' className='mr-3'
                                           {...register('remind2SB')}
                                           style={{border: errors.remind2SB && '1px solid red'}}
                                    />
                                    SB
                                </label>
                            </div>
                            <div className="space-y-4">
                                <div className='flex justify-start my-2'>
                                    <label className='w-2/12 -mr-3' style={{lineBreak: 'strict'}}>
                                        <input type='checkbox' className='mr-3'
                                               {...register('remind2cc')}
                                               style={{border: errors.remind2cc && '1px solid red'}}
                                        />
                                        cc ebenfalls an
                                    </label>
                                    <input type='text' placeholder='info@anymail.com'
                                           {...register('remind2ccText')}
                                           style={{border: errors.remind2ccText && '1px solid red'}}
                                           className='py-2 w-full text-grey'/>
                                </div>
                                <div className='flex justify-start gap-4 my-2 mt-8'>
                                    <h5 className='w-2/12 -mr-3'>Betreff: </h5>
                                    <input type='text' className='py-2 w-full text-grey'
                                           {...register('remind2subject')}
                                           style={{border: errors.remind2subject && '1px solid red'}}
                                    />
                                </div>
                                <div className=' gap-4 my-2 mt-8'>
                                    <div className='flex flex-wrap gap-10'>
                                        <h5 className='w-2/12 -mr-3'>Mail-Text: </h5>
                                        <span className={`text-modalBackDropColor`}>
                                                Platzhalter:
                                                    <span className='px-2'>{'{'}Meilenstein{'}'}</span>
                                                   <span className='px-2'>{'{'}Schritt{'}'}</span>
                                                   <span className='px-2'>{'{'}Tage{'}'}</span>
                                                   <span className='px-2'>{'{'}Firmenprojekt{'}'}</span>
                                            </span>
                                    </div>
                                    <textarea rows='8'
                                              className='border border-whiteDark rounded-sm w-full text-grey'
                                              {...register('remind2mail')}
                                              style={{
                                                  border: errors.remind2mail && '1px solid red', padding: '15px 40px'
                                              }}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="grid grid-cols-[15%_auto] gap-x-10 mb-4 bg-offWhite p-1">
                            <h2 className="text-xl font-bold text-mainBlue mr-3">Erinnerung 3</h2>
                            <div className="flex items-center space-x-2">
                                <span className="text-text">Versand nach</span>
                                <input
                                    className="w-12 py-1 px-2 border border-offWhite rounded text-mainBlue"
                                    placeholder="5"
                                    {...register('remind3days')}
                                    style={{border: errors.remind3days && '1px solid red'}}
                                />
                                <span className="text-text">Tagen</span>
                            </div>
                        </div>
                        <div className="grid grid-cols-[15%_auto] gap-x-10 mb-10">
                            <div className="space-y-3 border border-offWhite pl-3">
                                <label className={`block`}>
                                    an
                                </label>
                                <label className={'col-span-2 block'}>
                                    <input type='checkbox'
                                           className='mr-3'
                                           {...register('remind3Berater')}
                                           style={{border: errors.remind3Berater && '1px solid red'}}
                                    />
                                    {portal === 'dgg' ? 'Berater (Closer)' : 'Berater'}
                                </label>

                                <label className={`block`}>
                                    <input type='checkbox'
                                           className='mr-3'
                                           {...register('remind3VA')}
                                           style={{border: errors.remind3VA && '1px solid red'}}
                                    />
                                    VA
                                </label>

                                <label className={`block`}>
                                    <input type='checkbox'
                                           className='mr-3'
                                           {...register('remind3DGAPIAMS')}
                                           style={{border: errors.remind3DGAPIAMS && '1px solid red'}}
                                    />
                                    DGAPI AMS
                                </label>
                                <label className={`block`}>
                                    cc
                                </label>

                                {portal === 'dgg' ? <label className={`block`}>
                                    <input type='checkbox' className='mr-3'
                                           {...register('remind3ADM')}
                                           style={{border: errors.remind3ADM && '1px solid red'}}
                                    />
                                    ADM
                                </label> : <label className={`block`}>
                                    <input type='checkbox' className='mr-3'
                                           {...register('remind3FKB')}
                                           style={{border: errors.remind3FKB && '1px solid red'}}
                                    />
                                    FKB
                                </label>}

                                {portal === 'dgg' ? <label className={`block`}>
                                    <input type='checkbox' className='mr-3'
                                           {...register('remind3DGKAM')}
                                           style={{border: errors.remind3DGKAM && '1px solid red'}}
                                    />
                                    DG KAM
                                </label> : <label className={`block`}>
                                    <input type='checkbox' className='mr-3'
                                           {...register('remind3DGAPIKAM')}
                                           style={{border: errors.remind3DGAPIKAM && '1px solid red'}}
                                    />
                                    DGAPI KAM
                                </label>}


                                {portal === 'dgg' ? <label className={`block`}>
                                    <input
                                        type='checkbox' className='mr-3'
                                        {...register('remind3KGS')}
                                        style={{border: errors.remind3KGS && '1px solid red'}}
                                    />
                                    KGS
                                </label> : <label className={`block`}>
                                    <input
                                        type='checkbox' className='mr-3'
                                        {...register('remind3KBD')}
                                        style={{border: errors.remind3KBD && '1px solid red'}}
                                    />
                                    KBD
                                </label>}


                                {portal === 'dgg' ? <label className={`block`}>
                                    <input type='checkbox' className='mr-3'
                                           {...register('remind3VLHS')}
                                           style={{border: errors.remind3VLHS && '1px solid red'}}
                                    />
                                    VLHS
                                </label> : <label className={`block`}>
                                    <input type='checkbox' className='mr-3'
                                           {...register('remind3VBbV')}
                                           style={{border: errors.remind3VBbV && '1px solid red'}}
                                    />
                                    VBbV
                                </label>}

                                <label className={`block`}>
                                    <input type='checkbox' className='mr-3'
                                           {...register('remind3SB')}
                                           style={{border: errors.remind3SB && '1px solid red'}}
                                    />
                                    SB
                                </label>
                            </div>
                            <div className="space-y-4">
                                <div className='flex justify-start my-2'>
                                    <label className='w-2/12 -mr-3' style={{lineBreak: 'strict'}}>
                                        <input type='checkbox' className='mr-3'
                                               {...register('remind3cc')}
                                               style={{border: errors.remind3cc && '1px solid red'}}
                                        />
                                        cc ebenfalls an
                                    </label>
                                    <input type='text' placeholder='info@anymail.com'
                                           {...register('remind3ccText')}
                                           style={{border: errors.remind3ccText && '1px solid red'}}
                                           className='py-2 w-full text-grey'/>
                                </div>
                                <div className='flex justify-start gap-4 my-2 mt-8'>
                                    <h5 className='w-2/12 -mr-3'>Betreff: </h5>
                                    <input type='text' className='py-2 w-full text-grey'
                                           {...register('remind3subject')}
                                           style={{border: errors.remind3subject && '1px solid red'}}
                                    />
                                </div>
                                <div className=' gap-4 my-2 mt-8'>
                                    <div className='flex flex-wrap gap-10'>
                                        <h5 className='w-2/12 -mr-3'>Mail-Text: </h5>
                                        <span className={`text-modalBackDropColor`}>
                                                Platzhalter:
                                                       <span className='px-2'>{'{'}Meilenstein{'}'}</span>
                                                   <span className='px-2'>{'{'}Schritt{'}'}</span>
                                                   <span className='px-2'>{'{'}Tage{'}'}</span>
                                                   <span className='px-2'>{'{'}Firmenprojekt{'}'}</span>
                                            </span>
                                    </div>
                                    <textarea rows='8'
                                              className='border border-whiteDark rounded-sm w-full text-grey'
                                              {...register('remind3mail')}
                                              style={{
                                                  border: errors.remind3mail && '1px solid red',
                                                  padding: '15px 40px',
                                                  marginBottom: '5vh'
                                              }}
                                    />
                                </div>
                            </div>
                        </div>

                        {(getValues('triggerMilestoneID') && getValues('triggerMilestoneID') !== 'Wählen Sie einen Meilenstein aus') ?
                            <input
                                // className={`${isValid && TriggerMilestoneSelected && TriggerSubStepSelected ? 'bg-mainBlue cursor-pointer' : 'bg-grey cursor-no-drop '} w-44 float-right mt-4 text-white hover:bg-offWhite hover:text-mainBlue text-center px-3 py-2 rounded-md`}
                                className={`${(getValues('triggerMilestoneID') || getValues('triggerMilestoneID') !== 'Wählen Sie einen Meilenstein aus') ? 'bg-mainBlue cursor-pointer' : 'bg-grey cursor-no-drop '} w-44 float-right mt-4 text-white hover:bg-offWhite hover:text-mainBlue text-center px-3 py-2 rounded-md`}
                                type="submit"
                                onChange={() => console.log('saving')}
                                value={`${loadingSave ? 'speichere...' : 'Speichern'}`}
                            /> : <input
                                className={`bg-grey cursor-no-drop w-44 float-right mt-4 text-white hover:bg-offWhite hover:text-mainBlue text-center px-3 py-2 rounded-md`}
                                disabled
                                onChange={() => console.log('saving')}
                                value={`${loadingSave ? 'speichere...' : 'Speichern'}`}
                            />}
                    </form>
                    <input
                        className={`${milestoneSelected && SubStepSelected ? 'bg-cancel cursor-pointer' : 'bg-grey cursor-no-drop '} float-right mt-4 text-white w-44 hover:bg-offWhite hover:text-mainBlue text-center px-3 py-2 rounded-md mr-1`}
                        onClick={() => setDeleteClicked(true)}
                        onChange={() => console.log('deleting')}
                        value='Löschen'
                    />
                </div>}
            </div>}
    </div>)
}

export default InfoCrawler
